import { React } from "react";
import "../MyStyle/championsTrophy.css";
import { Navigation } from "./Navigation/Navigation";
import { QuestionAnswer } from "../QuestionAnswer/QuestionAnswer";

export const ChampionsTrophyBanner = () => {
  return (
    <>
      <div className="championsTrophyBanner">
        <div className="navBG"></div>
        <div className="container">
          <Navigation />
          <div className="bannerContent">
            <div className="pridictionWrapper">
              <div className="pridictWin">
                <img src="../images/championsTrophy/predictBanner.png" alt="" />
              </div>
              <div className="cheers">
                <img src="../images/championsTrophy/cheers.png" alt="" />
              </div>
            </div>
            <div className="quizContainer">
              <QuestionAnswer />
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
